import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  warning: {
    display: 'block',
    color: theme.colorPalette.green_30,
    fontSize: 14,
    lineHeight: 1.4
  },
  link: {
    display: 'inline',
    color: theme.colorPalette.green_30,
    textDecoration: 'underline'
  }
});

export default makeStyles(styles);
